import {
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";

import { trackEvent } from "utils/tracking";

const BlackFridayAnnouncement = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { setUpgradeDialogSource } = useContext(SubscriptionContext);

  const handleStartReferring = () => {
    trackEvent("Black Friday - View Plans Button Clicked");
    setUpgradeDialogSource("Black Friday - Home Page");
  };
  return (
    <Grid
      container
      alignItems="center"
      sx={{
        borderRadius: 2,
        boxShadow: 3,
        p: 3,
        mb: 3,
        mt: -3,
        backgroundColor: "purple.main",
      }}
      item
      xs={12}
    >
      <Grid item xs={12} md={7} lg={8} container alignItems="center">
        <Typography variant="h4" gutterBottom>
          BLACK FRIDAY SALE - 3 DAYS ONLY ⏳
        </Typography>

        <Typography>
          Get 25% off upgrades, add-ons, and annual plans, no coupon code
          needed. Plus, get a <strong>FREE EMAIL TEMPLATE</strong> with any
          annual plan.
        </Typography>
      </Grid>

      <Grid
        item
        xs
        md
        lg
        container
        justifyContent={isMobileScreen ? "flex-start" : "flex-end"}
        sx={{ pr: 2, mt: { xs: 2, md: 0 } }}
      >
        <Button
          sx={{
            backgroundColor: "yellow.main",
            color: "black",
            "&:hover": { backgroundColor: "yellow.main" },
          }}
          variant="contained"
          disableElevation
          onClick={handleStartReferring}
        >
          View Plans
        </Button>
      </Grid>
    </Grid>
  );
};

export default BlackFridayAnnouncement;
